/**
 * Created by Aleksandr on 29.11.2022
 */

const OrangeryView = cc.Node.extend({
    ctor: function (orangery) {
        this.orangery = orangery;
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER - 3);

        this.onResize();

        if (this.orangery.isBrushModeAvailable()) {
            this.createBrushButton();
            this.orangery.on("toggleBrushMode", this.updateBrushButton.bind(this), this);
        }

        this.createMinimized();

        if (this.orangery.maximized) {
            this.createMaximized();
            this.minimized.setVisible(false);
            this.maximized.setVisible(true);
        }

        cleverapps.aims.registerTarget("orangery", this, {
            controls: this.orangery.getControlName()
        });

        this.orangery.on("changeButton", this.updateMinimizedContent.bind(this), this);
        this.orangery.on("toggleButton", this.toggleVisibility.bind(this), this);
        this.orangery.on("toggleView", (state) => {
            if (state === undefined) {
                state = !this.maximized || !this.maximized.isVisible();
            }
            this.orangery.maximized = state;
            if (state) {
                this.showView();
            } else {
                this.hideView();
            }
        }, this);

        if (connector.info.isMobile && cleverapps.config.orientation === "horizontal") {
            this.setScale(1.5);
        }

        cleverapps.UI.onClick(this.minimized, this.onClick.bind(this));
    },

    onResize: function () {
        const styles = cleverapps.styles.OrangeryView;

        const position = styles.showPosition[cleverapps.config.type] || styles.showPosition;

        this.setContentSize2(styles.minimized);
        this.setAlignment(position);

        this.showPosition = position;
    },

    createMinimized: function () {
        const styles = cleverapps.styles.OrangeryView.minimized;

        const minimized = this.minimized = new cc.Node();

        minimized.setContentSize2(styles);
        minimized.setAlignment(styles.x / cc.view.getFrameSize().width * cleverapps.resolution.getSceneSize().width, styles.y);

        const bg = minimized.bg = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_dark);
        bg.setContentSize2(minimized.width, minimized.height);
        bg.setAlignment(minimized.width / 2, minimized.height / 2);
        minimized.addChild(bg);

        const innerBg = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_light);
        innerBg.setContentSize(minimized.width - styles.margin * 2, minimized.height - styles.margin * 2);
        innerBg.setAlignment(minimized.width / 2, minimized.height / 2);
        minimized.bg.addChild(innerBg);

        this.updateMinimizedContent();

        cleverapps.UI.applyHover(minimized.bg);

        this.addChild(minimized);
    },

    createMaximized: function () {
        this.orangery.init();

        const styles = cleverapps.styles.OrangeryView.maximized;

        const maximized = this.maximized = new cc.Node();
        maximized.setVisible(false);
        maximized.setAlignment(styles.positions);
        maximized.setLocalZOrder(3);

        const bg = maximized.bg = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_dark);
        maximized.addChild(bg);

        const content = maximized.content = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_light);
        maximized.addChild(content);

        const tabs = maximized.tabs = new Tabs(this.createTabs(), styles.tabs);
        tabs.setAlignment(tabs.width / 2, tabs.height / 2);

        maximized.addChild(tabs);

        cleverapps.UI.onDrag(maximized, {
            followPointer: true,
            filter: (touch) => cc.rectContainsPoint(bg.getGlobalBoundingBox(), touch.getLocation())
        });

        if (this.orangery.listTabs().length === 1) {
            tabs.setVisible(false);
        }

        const closeButton = maximized.closeButton = new CloseButton({
            onClicked: this.orangery.toggleView.bind(this.orangery, false)
        });
        maximized.addChild(closeButton);

        tabs.onTabChanged = this.maximized.createListener(this.onTabChanged.bind(this));

        tabs.activateTab(this.orangery.selectedTab || 0);

        maximized.setLocalZOrder(WindowComponent.WINDOWS_ZORDER - 2);

        this.addChild(maximized);

        cleverapps.UI.onClick(this.maximized, () => {}, {
            interactiveScale: false
        });
        cleverapps.UI.onClick(this, () => {}, {
            interactiveScale: false
        });
    },

    createTabs: function () {
        return this.orangery.listTabs().map((tab) => {
            tab.generator = this.maximized.createListener(this.createTab.bind(this, tab));
            return tab;
        });
    },

    createTab: function (tab) {
        const content = new OrangeryTab(this.orangery, tab);
        content.setAnchorPoint(0, 0);
        content.setAlignment(0, 0);
        this.maximized.content.addChild(content);
        return content;
    },

    updateMinimizedContent: function () {
        const minimized = this.minimized;

        if (minimized.itemIcon) {
            minimized.itemIcon.removeTemporarily();
        }

        if (minimized.itemTitle) {
            minimized.itemTitle.removeFromParent();
        }

        if (minimized.trashIcon) {
            minimized.trashIcon.removeFromParent();
        }

        const styles = cleverapps.styles.OrangeryView.minimized;

        if (!this.orangery.selected) {
            const plus = minimized.itemIcon = new cc.Sprite(bundles.dev_buttons.frames.plus);
            plus.setAlignment(minimized.width / 2, minimized.height / 2);
            minimized.bg.addChild(plus);
            return;
        }

        if (!this.orangery.selected.minimizedIcon) {
            this.orangery.selected.minimizedIcon = this.orangery.selected.getMinimizedIcon();
        }

        const icon = minimized.itemIcon = this.orangery.selected.minimizedIcon;
        minimized.bg.addChild(icon);
        icon.setAlignment(minimized.width / 2, minimized.height / 2);
        cleverapps.UI.fitToBox(icon, {
            width: styles.width,
            height: styles.height
        });

        const title = minimized.itemTitle = cleverapps.UI.generateOnlyText(this.orangery.getItemCode(this.orangery.selected), cleverapps.styles.FONTS.SYSTEM);
        title.setAlignment(styles.title);
        minimized.bg.addChild(title);

        const trashIcon = minimized.trashIcon = new cc.Sprite(bundles.dev_buttons.frames.delete_icon);
        cleverapps.UI.fitToBox(trashIcon, {
            height: styles.trash.height
        });
        trashIcon.baseScale = trashIcon.scale;
        minimized.bg.addChild(trashIcon);
        trashIcon.setAlignment(styles.trash);

        cleverapps.UI.applyHover(trashIcon);
        cleverapps.UI.onClick(trashIcon, () => {
            this.orangery.unselect(this.orangery.selected);
        });
    },

    onTabChanged: function (tabId) {
        this.updateMaximizedContent();

        if (["merge", "merge2", "farm"].includes(cleverapps.config.type) && cleverapps.config.editorMode) {
            let layer = this.orangery.data.tabs[tabId].layer;
            if (layer === undefined) {
                layer = Map2dEditor.LAYER_UNITS;
            }

            Editor.currentEditor.setLayer(layer);
        }
    },

    updateMaximizedContent: function () {
        const maximized = this.maximized;

        const tabContent = maximized.tabs.activeTab();

        const styles = cleverapps.styles.OrangeryView.maximized;
        const width = tabContent.width;
        const height = tabContent.height;
        const titleHeight = Math.max(maximized.tabs.height, maximized.closeButton.height);

        maximized.setContentSize(width + styles.margin * 2, height + styles.margin * 2 + titleHeight);

        maximized.bg.setAnchorPoint(0.5, 0.5);
        maximized.bg.setContentSize2(maximized.width, maximized.height);
        maximized.bg.setAlignment(maximized.width / 2, maximized.height / 2);

        maximized.content.setAnchorPoint(0, 0);
        maximized.content.setContentSize2(width, height);
        maximized.content.setAlignment(styles.margin, styles.margin);

        maximized.tabs.setAnchorPoint(0, 0.5);
        maximized.tabs.setAlignment(styles.margin, maximized.height - styles.margin - titleHeight / 2);

        maximized.closeButton.setAnchorPoint(1, 0.5);
        maximized.closeButton.setAlignment(styles.closeButton);
    },

    setVisible: function (visible) {
        if (visible && !this.orangery.buttonVisible) {
            return;
        }
        cc.Node.prototype.setVisible.call(this, visible);
    },

    toggleVisibility: function () {
        this.setVisible(this.orangery.buttonVisible);
    },

    showView: function () {
        if (!this.maximized) {
            this.createMaximized();
        }

        if (this.maximized.isVisible()) {
            return;
        }

        const options = this.prepareAnimation(this.maximized, this.minimized);
        this.maximized.setAlignment(options.to.x, options.to.y);
        this.maximized.setScale(options.scale.x, options.scale.y);
        this.maximized.setVisible(true);

        if (this.orangery.selectedTab) {
            this.maximized.tabs.activateTab(this.orangery.selectedTab);
        }

        // cleverapps.debugStats.setEnabled(false);

        this.maximized.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.ScaleTo(0.2, 1, 1),
                new cc.MoveTo(0.2, options.from.x, options.from.y)
            ),
            new cc.CallFunc(() => {
                this.minimized.setVisible(false);
            })
        ));
    },

    hideView: function () {
        if (!this.maximized || !this.maximized.isVisible()) {
            return;
        }

        const options = this.prepareAnimation(this.maximized, this.minimized);

        this.maximized.stopAllActions();
        this.maximized.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.ScaleTo(0.2, options.scale.x, options.scale.y),
                new cc.MoveTo(0.2, options.to.x, options.to.y)
            ),
            new cc.MoveTo(0, options.from.x, options.from.y),
            new cc.CallFunc(() => {
                // cleverapps.debugStats.setEnabled(cleverapps.flags.toggleStatsMode ? false : cleverapps.flags.debugInfo !== false);
                this.minimized.setVisible(true);
                this.maximized.removeFromParent();
                delete this.maximized;
            })
        ));
    },

    prepareAnimation: function (window, button) {
        const corners = [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 1, y: 1 }, { x: 0, y: 1 }];

        let selectedDistance = 0, selectedCorner = 0;
        for (let i = 0; i < corners.length; ++i) {
            const corner = corners[i];
            const distance = 1 / cc.pDistanceSQ(window.convertToWorldSpace(cc.p(corner.x * window.width, corner.y * window.height)), button.convertToWorldSpace(cc.p(corner.x * button.width, corner.y * button.height)));

            if (distance > selectedDistance) {
                selectedDistance = distance;
                selectedCorner = corner;
            }
        }

        const fromPosition = cc.p(window);
        const fromCorner = button.convertToNodeSpace(window.convertToWorldSpace(cc.p(selectedCorner.x * window.width, selectedCorner.y * window.height)));
        const toCorner = button.convertToNodeSpace(button.convertToWorldSpace(cc.p(selectedCorner.x * button.width, selectedCorner.y * button.height)));

        const scale = {
            x: button.width / window.width,
            y: button.height / window.height
        };

        const toPosition = cc.pSub(fromPosition, fromCorner);
        toPosition.x = toPosition.x * scale.x + toCorner.x;
        toPosition.y = toPosition.y * scale.y + toCorner.y;

        return {
            from: fromPosition,
            to: toPosition,
            scale
        };
    },

    createBrushButton: function () {
        const styles = cleverapps.styles.OrangeryView.brushButton;

        const brushButton = this.brushButton = new cc.Node();
        brushButton.setContentSize2(styles);
        brushButton.setAlignment(styles);

        const bg = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_dark);
        bg.setContentSize2(styles.width, styles.height);
        bg.setAlignment(styles.width / 2, styles.height / 2);
        brushButton.addChild(bg);

        const innerBg = brushButton.innerBg = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_light);
        innerBg.setContentSize(styles.width - styles.margin * 2, styles.height - styles.margin * 2);
        innerBg.setAlignment(styles.width / 2, styles.height / 2);
        bg.addChild(innerBg);

        const label = cleverapps.UI.generateOnlyText("B", cleverapps.styles.FONTS.ORANGERY_BRUSH_LABEL);
        label.setAlignment(styles.width / 2, styles.height / 2);
        bg.addChild(label);

        cleverapps.UI.applyHover(bg);

        cleverapps.UI.onClick(brushButton, () => this.orangery.toggleBrushMode());

        this.addChild(brushButton);

        this.createBrushSizeControls();
    },

    createBrushSizeControls: function () {
        const styles = cleverapps.styles.OrangeryView.brushSizeControls;

        const controls = this.brushSizeControls = new cc.Node();
        controls.setContentSize2(styles);
        controls.setAlignment(styles);
        controls.setVisible(false);

        const sizeLabel = this.brushSizeLabel = cleverapps.UI.generateOnlyText(this.getBrushSizeText(), cleverapps.styles.FONTS.ORANGERY_BRUSH_LABEL);
        sizeLabel.fitTo(styles.text.width);
        sizeLabel.setAlignment(styles.width / 2, styles.height / 2);
        controls.addChild(sizeLabel);

        const minusButton = this.createSizeButton("-", styles.minus, () => {
            this.orangery.setBrushSize(this.orangery.getBrushSize() - 1);
        });
        controls.addChild(minusButton);

        const plusButton = this.createSizeButton("+", styles.plus, () => {
            this.orangery.setBrushSize(this.orangery.getBrushSize() + 1);
        });
        controls.addChild(plusButton);

        this.orangery.on("changeBrushSize", this.updateBrushSizeLabel.bind(this), this);

        this.addChild(controls);
    },

    createSizeButton: function (text, styles, callback) {
        const button = new cc.Node();
        button.setContentSize2(styles);
        button.setAlignment(styles);

        const bg = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_dark);
        bg.setContentSize2(styles.width, styles.height);
        bg.setAlignment(styles.width / 2, styles.height / 2);
        button.addChild(bg);

        const innerBg = new cc.Scale9Sprite(bundles.dev_buttons.frames.orangery_bg_light);
        innerBg.setContentSize(styles.width - styles.margin * 2, styles.height - styles.margin * 2);
        innerBg.setAlignment(styles.width / 2, styles.height / 2);
        bg.addChild(innerBg);

        const label = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.ORANGERY_BRUSH_LABEL);
        label.setAlignment(styles.width / 2, styles.height / 2);
        bg.addChild(label);

        cleverapps.UI.applyHover(bg);
        cleverapps.UI.onClick(button, callback);

        return button;
    },

    updateBrushSizeLabel: function () {
        const styles = cleverapps.styles.OrangeryView.brushSizeControls;

        this.brushSizeLabel.setString(this.getBrushSizeText());
        this.brushSizeLabel.fitTo(styles.text.width);
    },

    getBrushSizeText: function () {
        const dims = this.orangery.getBrushDimensions();
        return `${dims.width}x${dims.height}`;
    },

    updateBrushButton: function () {
        const innerBg = this.brushButton.innerBg;

        if (this.orangery.isBrushMode()) {
            innerBg.setColor(new cc.Color(150, 200, 255));
        } else {
            innerBg.setColor(new cc.Color(255, 255, 255));
        }

        this.brushSizeControls.setVisible(this.orangery.isBrushMode());
    },

    onClick: function () {
        this.orangery.toggleView();
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ORANGERY_BRUSH_LABEL: {
        size: 56,
        color: new cc.Color(210, 175, 65)
    }
});

cleverapps.styles.OrangeryView = {
    showPosition: {
        x: { align: "left", dx: 250 },
        y: { align: "bottom", dy: 10 },

        "battlefield": {
            x: { align: "left", dx: 300 },
            y: { align: "bottom", dy: 10 }
        },

        "merge2": [
            {
                x: { align: "left", dx: 280 },
                y: { align: "bottom", dy: 10 }
            },
            {
                x: { align: "left", dx: 300 },
                y: { align: "bottom", dy: 10 }
            },
            {
                x: { align: "left", dx: 350 },
                y: { align: "bottom", dy: 10 }
            }
        ]
    },

    maximized: {
        margin: 10,

        positions: [
            {
                x: { align: "left", dx: -30 },
                y: { align: "bottom", dy: 100 }
            },
            {
                x: { align: "left", dx: 5 },
                y: { align: "bottom", dy: -5 }
            },
            {
                x: { align: "left", dx: 5 },
                y: { align: "bottom", dy: -5 }
            }
        ],

        tabs: {
            x: { align: "left", dx: 5 },
            y: { align: "top", dy: 67 },
            type: {
                off_png: bundles.dev_buttons.frames.orangery_bg_dark,
                on_png: bundles.dev_buttons.frames.orangery_bg_light
            },
            direction: cleverapps.UI.HORIZONTAL,
            width: 90,
            height: 70
        },

        closeButton: {
            x: { align: "right", dx: 30 },
            y: { align: "top", dy: 30 }
        }
    },

    brushButton: {
        width: 100,
        height: 100,

        x: { align: "left", dx: 110 },
        y: { align: "bottom", dy: 0 },

        margin: 10
    },

    brushSizeControls: {
        width: 200,
        height: 60,

        text: {
            width: 80
        },

        x: { align: "left", dx: 220 },
        y: { align: "bottom", dy: 20 },

        minus: {
            width: 60,
            height: 60,
            margin: 6,

            x: { align: "left" },
            y: { align: "center" }
        },

        plus: {
            width: 60,
            height: 60,
            margin: 6,

            x: { align: "right" },
            y: { align: "center" }
        }
    },

    minimized: {
        width: 100,
        height: 100,

        x: 0,
        y: 0,

        margin: 10,

        trash: {
            height: 35,

            x: { align: "right" },
            y: { align: "top", dy: 10 }
        },

        title: {
            x: { align: "center" },
            y: { align: "top", dy: 25 }
        }
    }
};
